module.exports = __webpack_public_path__ + "img/editButton.3f7a3df7.png";